import { deleteMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin, getUserRole } from 'utils/general';

// Action Types
export const DELETE_SERVICE = 'DELETE_SERVICE';
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS';
export const DELETE_SERVICE_FAILURE = 'DELETE_SERVICE_FAILURE';

// Action Creators
export const fetchDeleteService = () => ({
  type: DELETE_SERVICE,
});

export const fetchDeleteServiceSuccess = (data) => ({
  type: DELETE_SERVICE_SUCCESS,
  payload: data,
});

export const fetchDeleteServiceFailure = (error) => ({
  type: DELETE_SERVICE_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteServiceCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchDeleteService(data, external));
    try {
      const userRole = getUserRole();
      const response = await deleteMethodWithToken(
        userRole === 'super-admin'
          ? url.deleteServiceListSuperAdmin +
              external?.id +
              '/' +
              'delete' +
              '/'
          : url.deleteSubCategoryServiceProviderAdmin + external?.id + '/'
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchDeleteServiceSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchDeleteServiceFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchDeleteServiceFailure(error.message));
    }
  };
};
